/**
 * Error message for when a given request has already been signed.
 *
 * @type {String}
 */
export const REQUEST_ALREADY_SIGNED = 1107;
export const REQUEST_INVALID_SIGNATURE_STATUS = 1112;
